import Vue from 'vue';

export const mutations = {
  setViewInfo(state, payload) {
    state.viewInfo = payload;
  },
  setListDeletedRows(state, payload) {
    state.listDeletedRows = payload;
  },
  setCheckboxSelectedRows(state, payload) {
    state.checkboxSelectedRows = payload;
  },
  setCellsVersions(state, payload) {
    state.cellsVersions = payload;
  },
  setUpdatingCol(state, payload) {
    const { projectId, col } = payload;
    if (!state.updatingCols[projectId]) {
      Vue.set(state.updatingCols, projectId, {
      });
    }
    Vue.set(state.updatingCols[projectId], col, 1);
  },
  removeUpdatingCol(state, payload) {
    const { projectId, col } = payload;
    if (state.updatingCols[projectId] && state.updatingCols[projectId][col]) {
      Vue.set(state.updatingCols[projectId], col, state.updatingCols[projectId][col] - 1);
    }
  },
};
